<template>
  <section
    :class="{'date-input --horizontal': isHorizontal}"
    class="date-input"
  >
    <label v-if="label">{{ label }}</label>
    <div class="container">
      <ul>
        <li>
          <input
            type="text"
            placeholder="jj"
            :maxlength="2"
            v-model="day"
          >
        </li>
        <li>
          <i>/</i>
        </li>
        <li>
          <input
            type="text"
            placeholder="mm"
            :maxlength="2"
            v-model="month"
          >
        </li>
        <li>
          <i>/</i>
        </li>
        <li>
          <input
            type="text"
            placeholder="aaaa"
            :maxlength="4"
            v-model="year"
          >
        </li>
        <input
          type="text"
          class="prevent-autocomplete"
        >
      </ul>
      <slot />
    </div>
  </section>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    error: {
      type: Object,
      default: null,
    },
    isHorizontal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      day: null,
      month: null,
      year: null,
    }
  },
  mounted() {
    if (this.value) {
      this.day = this.value.day
      this.month = this.value.month
      this.year = this.value.year
    }
  },
  methods: {
    getFullDate() {
      const dateObject = {
        day: { category: 'day', value: this.day },
        month: { category: 'month', value: this.month },
        year: { category: 'year', value: this.year },
      }
      const isEmptyDate = !this.day && !this.month && !this.year
      const birthdayValue = {
        value: isEmptyDate ? '' : `${dateObject.year.value}-${dateObject.month.value}-${dateObject.day.value}`,
        name: this.name,
        category: 'custom',
      }
      return birthdayValue
    },
  },
  watch: {
    value(value) {
      this.day = value.day
      this.month = value.month
      this.year = value.year
    },
    day(val) {
      const inputValue = {
        value: val,
        name: this.name,
        category: 'day',
      }

      this.$emit('updatedDateInputs', inputValue)
      this.$emit('updatedDateInputs', this.getFullDate())
    },
    month(val) {
      const inputValue = {
        value: val,
        name: this.name,
        category: 'month',
      }

      this.$emit('updatedDateInputs', inputValue)
      this.$emit('updatedDateInputs', this.getFullDate())
    },
    year(val) {
      const inputValue = {
        value: val,
        name: this.name,
        category: 'year',
      }

      this.$emit('updatedDateInputs', inputValue)
      this.$emit('updatedDateInputs', this.getFullDate())
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../../../../_src/sass/config/vars';
@import '../../../../../../_src/sass/config/mixins';
@import '../../../../../../_src/sass/config/responsive';

.date-input {
  .prevent-autocomplete {
    border: hidden;
    height: 0;
    position: absolute;
    width: 0;
    z-index: -9999;
  }

  .container {
    display: flex;
    flex: 1;
    flex-direction: column;
  }

  .error {
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    text-align: left;
    width: 100%;

    span {
      @include errorInputs;

      flex: 0;
    }
  }

  &.--horizontal {
    display: flex;

    label {
      flex: 1;
    }

    ul {
      display: flex;
      flex: 1;
    }
  }

  label {
    @include labels;

    display: block;
    margin-bottom: 10px;
    margin-top: 15px;
  }

  ul {
    display: flex;
    max-width: 280px;
    position: relative;

    li {
      display: flex;

      /* flex: 1; */
      flex-direction: column;

      i {
        padding: 0 10px;
        text-align: center;
        width: 100%;
      }

      input {
        @include sharable-input;

        flex: 0;
        height: 36px;
        width: 100%;
      }

      &:nth-child(odd) {
        /* width: 25%; */
        flex: 1;

        div {
          bottom: -20px;
          position: absolute;
          width: 100%;

          span {
            @include errorInputs;

            width: 100%;
          }
        }
      }

      &:nth-child(even) {
        align-content: center;
        align-items: center;
        flex: 0;
        height: 36px;
        justify-content: center;
        text-align: center;
      }

      &:last-child {
        input {
          padding: 0 8px;
        }
      }
    }
  }
}
</style>
